import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      marginTop: '10px',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
